import { Component, OnInit, Input, ChangeDetectorRef } from '@angular/core';
import { LegacyPageEvent as PageEvent } from '@angular/material/legacy-paginator';
import { TranslateService } from '@ngx-translate/core';
import Swal from 'sweetalert2';

import {
  AtMentionItem,
  AtMentionItemType,
} from '@app/core/_common/at-mention/at-mention.model';
import { CommentType, CommentService } from '@app/core/messaging';
import { StaffService } from '@app/core/staff';

@Component({
  selector: 'cnc-comment-form',
  templateUrl: './comment-form.component.html',
  styleUrls: ['./comment-form.component.scss'],
})
export class CommentFormComponent implements OnInit {
  constructor(
    public commentSvc :CommentService,
    private translate :TranslateService,
    private cd :ChangeDetectorRef,
    private staffService :StaffService,
  ) {}

  filesToUpload :any[] = [];
  imagesToUpload :any[] = [];

  commentText :string = '';
  loading :boolean = false;
  staff = [] as AtMentionItem[];

  @Input() commentType :CommentType;

  ngOnInit() {
    this.staffService.staff$.subscribe((staff) => {
      this.staff = staff.map<AtMentionItem>((user) => ({
        id: user.id,
        name: user.handle,
        type: 'user' as AtMentionItemType,
      }));
    });
  }

  resetFields() {
    this.filesToUpload = [];
    this.imagesToUpload = [];
    this.commentText = '';
  }

  addComment() {
    if (!this.commentText || this.commentText.trim().length == 0) {
      return;
    }
    this.loading = true;
    const data = new FormData();
    data.append('comment', this.commentText);
    data.append('parent_id', '0');
    data.append('ref_tab_id', this.commentType.ref_tab_id.toString());
    data.append('ref_tab_type', this.commentType.ref_tab_type.toString());
    this.filesToUpload.forEach((file) => {
      data.append('file[]', file);
    });
    this.imagesToUpload.forEach((img) => {
      data.append('file[]', img.file);
    });
    this.commentSvc.postComment(data).subscribe(
      (resp) => {
        this.resetFields();
        this.loading = false;
      },
      (err) => {
        this.loading = false;
      },
    );
    // this.resetFields();
  }

  handleImageInput(event :any) {
    const files = Array.prototype.slice.call(event.target.files);
    const kani = this;
    let maxSizeError = false;
    files.forEach((file, idx) => {
      if (file.size > 10000000) {
        maxSizeError = true;
      } else {
        const ftu :any = {
          previewSrc: '',
          file: file,
        };
        this.imagesToUpload.push(ftu);
        if (file.type.toString().search('image') >= 0) {
          const index = this.imagesToUpload.length - 1;
          const fReader = new FileReader();
          fReader.readAsDataURL(file);
          fReader.onload = function (e :any) {
            kani.imagesToUpload[index].previewSrc = e.target.result;
            kani.cd.detectChanges();
          };
        }
      }
    });
    if (maxSizeError) {
      this.maxSizeError();
    }
    event.target.value = '';
  }

  handleFileInput(event :any) {
    const files = Array.prototype.slice.call(event.target.files);
    let maxSizeError = false;
    files.forEach((file, idx) => {
      if (file.size > 10000000) {
        maxSizeError = true;
      } else {
        this.filesToUpload.push(file);
      }
    });
    if (maxSizeError) {
      this.maxSizeError();
    }
    event.target.value = '';
  }

  maxSizeError() {
    Swal.fire({
      title: this.translate.instant('MESSAGES.FILE_MAX_SIZE_ERROR.TITLE'),
      text: this.translate.instant('MESSAGES.FILE_MAX_SIZE_ERROR.TEXT'),
      type: 'error',
      confirmButtonText: this.translate.instant('BUTTONS.OKAY'),
    });
  }
}
